import { c as _c } from "react-compiler-runtime";
import { useEffect, useState } from 'react';
import usePrevious from './usePrevious';
import { trackInteraction } from 'collaboration-sidebar/utils/usageTracker';
export default function useTrackLiveRefresh(t0) {
  "use memo";

  const $ = _c(8);
  const {
    unreadCommentsCount: count,
    unreadCommentsLoading: loading
  } = t0;
  const [hasLoadedInitialCount, setHasLoadedInitialCount] = useState(false);
  const fetchedCount = hasLoadedInitialCount ? count : null;
  const prevFetchedCount = usePrevious(fetchedCount);
  const prevLoading = usePrevious(loading);
  let t1;
  let t2;
  if ($[0] !== loading || $[1] !== prevLoading) {
    t1 = () => {
      if (prevLoading && !loading) {
        setHasLoadedInitialCount(true);
      }
    };
    t2 = [prevLoading, loading];
    $[0] = loading;
    $[1] = prevLoading;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[4] !== fetchedCount || $[5] !== prevFetchedCount) {
    t3 = () => {
      if (typeof fetchedCount === "number" && typeof prevFetchedCount === "number" && fetchedCount > prevFetchedCount) {
        trackInteraction({
          action: "New comments while viewing asset"
        });
      }
    };
    t4 = [fetchedCount, prevFetchedCount];
    $[4] = fetchedCount;
    $[5] = prevFetchedCount;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
}